document.addEventListener('DOMContentLoaded', function () {
    const sliders = document.querySelectorAll('.js-custom-slideshow');

    if (!sliders.length || typeof Flickity === 'undefined') return;

    sliders.forEach(function (slider) {
      const autoplay = slider.dataset.autoplay === 'true';
      const autoplaySpeed = Number(slider.dataset.autoplaySpeed) || 5000;
      const showDots = slider.dataset.showDots === 'true';
      const showArrows = slider.dataset.showArrows === 'true';

      new Flickity(slider, {
        cellSelector: '.custom-slideshow__slide',
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        imagesLoaded: true,
        pageDots: showDots,
        prevNextButtons: showArrows,
        autoPlay: autoplay ? autoplaySpeed : true,
        pauseAutoPlayOnHover: true,
        draggable: true
      });
    });
  });